import { createStyles } from "antd-style";

export const useModalFormStyles = createStyles(({ token, css }: any) => ({
  root: css`
    position: relative;
  `,
  loader: css`
    position: absolute;
    inset: 0;
    margin: auto;
    background: ${token.ColorFigmaNeutralWhiteWhite100};
    z-index: 1;
  `,
}));
